export function makeGradeData (data) {
  const gradeGroup = {
    name: data.name,
    grade_group_description: data.grade_group_description,
    is_default: !!data.is_default,
  }

  const grades = data.grades.map((element, index) => {
    return {
      ['grades[' + (index + 1) + '][id]']: element.id,
      ['grades[' + (index + 1) + '][name]']: element.name,
      ['grades[' + (index + 1) + '][grade_description]']: element.grade_description,
      ['grades[' + (index + 1) + '][grade_min_score_pc]']: element.grade_min_score_pc,
      ['grades[' + (index + 1) + '][grade_credit_point]']: element.grade_credit_point,
    }
  })

  let gradesData = {}

  grades.forEach(element => {
    gradesData = { ...gradesData, ...element }
  })

  const returnData = { ...gradeGroup, ...gradesData }

  return returnData
}
